<template>
  <div class="mt-16">
    <div class="btn-list">
      <WsButton001
        outLine
        flatButton
        class="todo-card-sort__btn"
        @click="$emit('add-sub-task-from-task')"
      >
        {{ $t('依任務來新增待辦') }}
      </WsButton001>
      <div
        v-if="isSorting"
        class="todo-card-sort__btn-list"
      >
        <WsButton001
          out-line
          flat-button
          class="todo-card-sort__btn"
          @click="$_sortingComplete()"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          primary
          flat-button
          class="todo-card-sort__btn"
          @click="$_sortingSave()"
        >
          {{ $t('送出') }}
        </WsButton001>
      </div>
      <div v-else class="todo-card-sort__btn-list">
        <WsButton001
          outLine
          flatButton
          class="todo-card-sort__btn"
          @click="$emit('click-batch')"
        >
          {{ $t('批次編輯') }}
        </WsButton001>
        <WsButton001
          outLine
          flatButton
          class="todo-card-sort__btn"
          @click="$_sortingStart()"
        >
          {{ $t('排序') }}
        </WsButton001>
      </div>
    </div>
    <div
      v-if="isSorting"
      class="ll-editable-question-list_list-wrap"
    >
      <div class="ll-editable-question-list_list">
        <SlickList v-model="sortingQuesList">
          <SlickItem
            v-for="(sortingItem,sortingIndex) in sortingQuesList"
            :key="sortingIndex"
            class="list-item"
            :index="sortingIndex"
          >
            <SortingChecklistQuestion
              :title="sortingItem.name"
              :ques-num="sortingIndex+1"
              :subtitle="sortingItem.remark"
            />
          </SlickItem>
        </SlickList>
      </div>
    </div>
  </div>
</template>
<script>
import { SlickList, SlickItem } from "vue-slicksort";

export default {
  name: "TodoCardSort",
  components: {
    SlickList,
    SlickItem,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    isSorting: false,
    sortingQuesList: [],
    C_questionList: [],
  }),
  watch: {
    list: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.C_questionList = newValue;
      },
    },
    C_questionList: {
      deep: true,
      handler() {
        this.$emit("question-edit", this.C_questionList);
      },
    },
    isSorting: {
      deep: true,
      handler() {
        this.$emit("sorting-active", this.isSorting);
      },
    },
  },
  mounted() {
    this.C_questionList = [...this.list];
  },
  methods: {
    $_sortingStart() {
      this.isSorting = true;
      this.sortingQuesList = JSON.parse(JSON.stringify(this.C_questionList));
    },
    $_sortingSave() {
      this.$_setSequence();
      this.C_questionList = this.sortingQuesList;
      this.$_sortingComplete();
    },
    $_sortingComplete() {
      this.$emit("sorting-complete", this.C_questionList);
      this.isSorting = false;
    },
    $_setSequence() {
      this.sortingQuesList.forEach((item, index) => {
        item.sequence = String(index + 1).padStart(3, "0");
      });
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-editable-question-list";
.btn-list {
  @include flex_justify(space-between);
  margin-bottom: 20px;
  .todo-card-sort__btn-list {
    @include flex;
    width: 100%;
    justify-content: flex-end;
    @media (max-width: 1023px) {
      flex-direction: column;
    }
    .todo-card-sort__btn {
      @include auto_margin_left(8px);
      @media (max-width: 1023px) {
        @include auto_margin_left(0px);
        @include auto_margin_top(8px);
        width: 100%;
      }
    }
  }
}
</style>